import * as z from "zod";

export const orderlessAuth = {
  name: "orderlessAuth" as const,
  input: z.object(),
  output: z.object({ customerAuthToken: z.string() }),
};
